import React, { useCallback, useEffect, useState } from 'react';
const NAMES = ['Valentina', 'Camila', 'Sofía', 'Isabella', 'Daniela', 'Luciana', 'Mariana', 'Gabriela', 'Fernanda', 'Alejandra', 'Catalina', 'Natalia', 'Valeria', 'Paola', 'Andrea'];
const CITIES = ['Buenos Aires', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Quito', 'Caracas', 'Medellín', 'Rosario', 'Córdoba', 'Asunción', 'La Paz', 'Guayaquil', 'Cali', 'Mendoza'];
const PRODUCT = 'Dulce Libertad';
const PRICE = '$6.39';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/1xeyM8XY99HJAJT6xgmREj/heroprod.jpg';
const VISIBLE_DURATION = 3000;
const FADE_DURATION = 600;
const WAIT_DURATION = 8000;
type Phase = 'hidden' | 'entering' | 'visible' | 'leaving';
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SalesNotification() {
  const [phase, setPhase] = useState<Phase>('hidden');
  const [name, setName] = useState(getRandom(NAMES));
  const [city, setCity] = useState(getRandom(CITIES));
  const runCycle = useCallback(() => {
    setName(getRandom(NAMES));
    setCity(getRandom(CITIES));
    setPhase('entering');
    const visibleTimer = setTimeout(() => setPhase('visible'), 400);
    const leaveTimer = setTimeout(() => setPhase('leaving'), 400 + VISIBLE_DURATION);
    const hideTimer = setTimeout(() => setPhase('hidden'), 400 + VISIBLE_DURATION + FADE_DURATION);
    return () => {
      clearTimeout(visibleTimer);
      clearTimeout(leaveTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      runCycle();
      const interval = setInterval(runCycle, 400 + VISIBLE_DURATION + FADE_DURATION + WAIT_DURATION);
      return () => clearInterval(interval);
    }, 2000);
    return () => clearTimeout(initialDelay);
  }, [runCycle]);
  if (phase === 'hidden') return null;
  const isEntering = phase === 'entering';
  const isLeaving = phase === 'leaving';
  return <>
      <style data-id="element-459">{`
        @keyframes ios-bounce-in {
          0%   { opacity: 0; transform: translateY(24px) scale(0.92); }
          60%  { opacity: 1; transform: translateY(-4px) scale(1.02); }
          80%  {             transform: translateY(2px)  scale(0.99); }
          100% { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        @keyframes ios-fade-out {
          0%   { opacity: 1; transform: translateY(0)   scale(1);    }
          70%  { opacity: 0.3; transform: translateY(4px) scale(0.98); }
          100% { opacity: 0; transform: translateY(10px) scale(0.96); }
        }
        .ios-enter { animation: ios-bounce-in 0.4s cubic-bezier(0.34,1.56,0.64,1) forwards; }
        .ios-leave { animation: ios-fade-out  0.6s ease-in-out forwards; }
      `}</style>

      {/*
            Outer div: fixed positioning only — never animated, never has transform
            so the centering (left-0 right-0 flex justify-center) is always stable
          */}
      <div style={{
      position: 'fixed',
      bottom: '20px',
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      padding: '0 16px',
      zIndex: 9999,
      pointerEvents: 'none'
    }}
    // Mobile only — hide on screens >= 768px
    className="md:hidden" role="status" aria-live="polite" data-id="element-460">
        {/* Inner div: animated only, no positioning transforms */}
        <div className={isEntering ? 'ios-enter' : isLeaving ? 'ios-leave' : ''} style={{
        width: '100%',
        maxWidth: '360px',
        pointerEvents: 'auto'
      }} data-id="element-461">
          {/* Card */}
          <div style={{
          background: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)',
          borderRadius: '16px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.13), 0 1px 4px rgba(0,0,0,0.08), inset 0 0 0 0.5px rgba(255,255,255,0.7)',
          padding: '10px 12px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }} data-id="element-462">
            {/* Product thumbnail */}
            <div style={{
            width: '44px',
            height: '44px',
            borderRadius: '10px',
            overflow: 'hidden',
            flexShrink: 0,
            boxShadow: '0 1px 4px rgba(0,0,0,0.15)'
          }} data-id="element-463">
              <img src={PRODUCT_IMAGE} alt={PRODUCT} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block'
            }} data-id="element-464" />
            </div>

            {/* Text */}
            <div style={{
            flex: 1,
            minWidth: 0
          }} data-id="element-465">
              {/* Row 1: label + time */}
              <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2px'
            }} data-id="element-466">
                <span style={{
                fontSize: '10px',
                fontWeight: 600,
                color: 'rgba(60,60,67,0.55)',
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif'
              }} data-id="element-467">
                  Compra reciente
                </span>
                <span style={{
                fontSize: '11px',
                color: 'rgba(60,60,67,0.4)',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif'
              }} data-id="element-468">
                  ahora
                </span>
              </div>

              {/* Row 2: name + city */}
              <p style={{
              fontSize: '13px',
              fontWeight: 700,
              color: '#1c1c1e',
              lineHeight: '1.3',
              margin: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif'
            }} data-id="element-469">
                {name}{' '}
                <span style={{
                fontWeight: 400,
                color: 'rgba(60,60,67,0.7)'
              }} data-id="element-470">
                  de {city}
                </span>
              </p>

              {/* Row 3: product + price */}
              <p style={{
              fontSize: '12px',
              color: 'rgba(60,60,67,0.75)',
              margin: 0,
              lineHeight: '1.3',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif'
            }} data-id="element-471">
                acaba de comprar{' '}
                <span style={{
                color: '#8B5E3C',
                fontWeight: 600
              }} data-id="element-472">
                  {PRODUCT}
                </span>{' '}
                por{' '}
                <span style={{
                color: '#2c7a2c',
                fontWeight: 700
              }} data-id="element-473">
                  {PRICE}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>;
}